<template>
  <div class="productpage__largeimage">
    <img
      v-if="showSuddenInfo"
      src="~/assets/images/temporary-images/ultimas-unidades-garrafas.png"
      alt="Last units Garrafa Fresh"
      :class="[
        'productpage__sudden-promo-img',
        'productpage__sudden-promo-img--small',
      ]"
    />

    <img
      v-if="showSuddenPromo"
      src="~/assets/images/temporary-images/promo_garrafa_square.webp"
      alt="Garrafa Square Colors"
      :class="[
        'productpage__sudden-promo-img',
        'productpage__sudden-promo-img--small',
      ]"
    />

    <div id="main-image" ref="mainImage" class="position--relative">
      <img
        v-if="!$store.state.userInteracted && material && mockupPreviews"
        class="productpage__default-image"
        :src="defaultImage"
        alt="Default Product Image"
      />
      <transition name="fade">
        <gallery-component
          v-if="$store.state.userInteracted && material && mockupPreviews"
          :canvas="null"
          :canvas-component="null"
          :gallery-props="galleryProps"
        />
      </transition>
    </div>
    <transition name="fade">
      <div
        v-show="$store.state.product.restartingEngine"
        class="productpage__logo"
      >
        <logo-loading />
      </div>
    </transition>
  </div>
</template>

<script>
import { PREVIEW_HOST } from '~/config'
import toQueryString from '~/utils/toQueryString'
import customValuesImageParser from '~/utils/customValuesImageParser'
import mockupApi from '~/mixins/api/go-catalog-api/mockups-api/mockups.api.js'
import LogoLoading from '~/components/loadings/logo'

const GalleryComponent = () =>
  import(
    /* webpackChunkName: "gallery-component"  */ '@gocasebr/go-shared/dist/gallery-component/GalleryComponent'
  )

export default {
  name: 'ProductImageContainer',
  components: { GalleryComponent, LogoLoading },
  mixins: [mockupApi],
  props: {
    galleryItems: {
      type: Array,
      default: () => [],
    },
    mockups: {
      type: Array,
      default: () => [],
    },
    store: {
      type: String,
      default: '',
    },
    sku: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      material: null,
      mockupPreviews: null,
    }
  },
  computed: {
    showSuddenInfo() {
      // return this.$isBrStore && this.sku?.includes('fresh')
      return false
    },
    showSuddenPromo() {
      // return this.$isBrStore && this.sku?.includes('lancheira')
      return false
    },
    defaultImage() {
      let img =
        this.material && this.mockupPreviews
          ? this.galleryItems?.[0]?.url
          : null
      if (
        this.$store.state?.isUsStore &&
        img?.match('newecodeluxegocustomized')
      ) {
        img = img.replace('newecodeluxegocustomized', 'caseimpactslimstandard')
      }

      if (this.$store.state?.isUsStore && img?.match('standardprinteers')) {
        img = img.replace('standardprinteers', 'caseimpactslimstandard')
      }
      return img
    },
    boxSize() {
      return this.$refs.mainImage.offsetWidth || 0
    },
    galleryProps() {
      return {
        material: this.resourceMaterial(this.material),
        height: this.boxSize,
        timestamp: 1,
      }
    },
  },
  mounted() {
    // Method: From MockupAPI mixins
    this.getMockup({ mockups: this.mockups, store: this.store })
      .then((res) => (this.material = res))
      .then(
        () =>
          (this.mockupPreviews = this.material.mockupPreviews.filter(
            (m) => m.jsClass !== 'MockupPreviewDynamicModel'
          ))
      )
  },
  methods: {
    resourceMaterial(material) {
      const { mockupPreviews, galleryItems, resourceItem } = this
      material.mockupPreviews = [
        ...galleryItems.map((item, i) => resourceItem(item, i)),
        ...mockupPreviews,
      ]

      const sku = this.$store.state?.product?.sku
      const isPelicula = sku?.match('pelicula')

      if (isPelicula || sku?.match('magsafe')) {
        const src = isPelicula
          ? 'https://www.youtube.com/embed/z_TiPqL88zE'
          : 'https://www.youtube.com/embed/02MuOTdge-M'
        material.mockupPreviews.push({
          id: 312,
          jsClass: 'MockupPreviewYoutubeModel',
          order: 0,
          active: true,
          scale: 1,
          translateX: 0,
          translateY: 0,
          previewYoutube: {
            id: 1112,
            jsClass: 'PreviewYoutubeModel',
            key: src,
            src,
            order: 0,
          },
        })
      }

      return material
    },
    // That hash is the same used by catalog
    resourceItem(item, i) {
      const src = this.itemSrc(item)

      return {
        id: null,
        jsClass: 'MockupPreviewImageModel',
        order: i,
        active: true,
        scale: 1,
        translateX: 0,
        translateY: 0,
        previewImage: {
          id: null,
          jsClass: 'PreviewImageModel',
          key: src,
          src,
          order: 0,
        },
      }
    },
    itemSrc(item) {
      if (item?.engine && item?.material) return item.url
      else if (item?.sku && item?.material && !item?.isKit)
        return this.src(item)
      else return item.url
    },
    src(item) {
      const dirName =
        process.env.NODE_ENV !== 'production' ? 'dev' : 'custom-pictures'
      const customValues = customValuesImageParser(item.customValues, dirName)

      const urlParams = toQueryString(customValues, {
        removeBlankKeys: true,
      }).toString()

      return `${PREVIEW_HOST}/${item.sku}/${item.material}/mockup?${urlParams}`
    },
  },
}
</script>

<style lang="scss">
.productpage__largeimage {
  position: relative;
  transition: top 2s ease 0s;
}

.productpage__logo {
  position: absolute;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #f2f2f4;
  max-width: 550px;
  width: 100%;

  > svg {
    margin: auto;
    margin-top: 45%;
  }

  @media (max-width: $v4_desktop) {
    > svg {
      margin-top: 40%;
    }
  }
}

@media (max-width: $v4_desktop) {
  .productpage__largeimage > div {
    height: 0;
    padding-bottom: 100%;
    background: #f2f2f4;
  }
}

.productpage__default-image {
  width: 100%;
}

.productpage__sudden-promo-img {
  margin-left: 30px;
  margin-top: 10px;
  width: 70px;
  position: absolute;
  z-index: 100;
  left: 0;
  top: 0;
}

@media (min-width: $v4_desktop) {
  .productpage__sudden-promo-img {
    margin-left: 80px;
    margin-top: 10px;
    width: 90px;
  }
}
</style>
